<template>
  <div>
    <el-descriptions :column="3">
      <el-descriptions-item label="订单状态">{{ info.stateStr }}</el-descriptions-item>
      <el-descriptions-item label="联系电话">
        <div :class="!isOpenSet ? 'flex' : 'flex flex-col'">
          <yd-link
            v-if="userList.includes(info.senderMobilePhone)"
            permi="user_center_manage"
            :value="info.senderMobilePhone"
            :url="phoneUrl(info, info.senderMobilePhone)"
            type="userInfo"
            :need="true"
          />
          <span v-else>{{ info.senderMobilePhone }}</span>
          <span style="padding-left: 10px" v-if="!isOpenSet">
            <el-button
              type="primary"
              size="mini"
              @click="handleOpenSet"
              v-has-permi="['order_intercity_editPhone']"
              >修改电话</el-button
            >
          </span>
          <span v-if="isOpenSet">
            <el-input
              v-model="newMobile"
              clearable
              placeholder="请输入电话号码"
              maxlength="11"
              show-word-limit
              style="width: 150px; padding: 0 3px"
            />
            <el-button size="mini" @click="phoneCancel">取消</el-button>
            <el-button type="success" size="mini" @click="submit">确定</el-button>
          </span>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="下单人电话">
        <yd-link
          v-if="userList.includes(info.mobilePhone)"
          permi="user_center_manage"
          :value="info.mobilePhone"
          :url="phoneUrl(info, info.mobilePhone)"
          type="userInfo"
          :need="true"
        />
        <span v-else>{{ info.mobilePhone }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="关联改签订单号">--</el-descriptions-item>
      <el-descriptions-item label="优惠券/活动名称">--</el-descriptions-item>
      <el-descriptions-item label="抵扣金额">--</el-descriptions-item>
      <el-descriptions-item label="订票来源">{{ info.buyChannelStr }}</el-descriptions-item>
      <!-- <el-descriptions-item label="云推官名称">{{ info.agentName || '--' }}</el-descriptions-item>
      <el-descriptions-item label="云推官手机号">{{ info.agentPhone || '--' }}</el-descriptions-item> -->
      <el-descriptions-item label="乘客备注">{{
        info.remarksPassenger || '--'
      }}</el-descriptions-item>
      <el-descriptions-item label="后台备注" span="2">
        <div style="display: flex">
          <sapn>{{ info.remarksBackstage || '--' }}</sapn>
          <span v-if="!isOpenRemark" style="padding-left: 10px">
            <el-button
              type="primary"
              size="mini"
              @click="openBtn"
              v-has-permi="['order_intercity_setRemark']"
              >设置备注
            </el-button>
          </span>
          <sapn style="padding-left: 10px" v-if="isOpenRemark">
            <el-input
              type="textarea"
              :rows="2"
              v-model="newRemark"
              placeholder="请输入备注"
              style="width: 20vw"
            />
            <el-button size="mini" @click="remarkCancel">取消</el-button>
            <el-button type="success" size="mini" @click="sumitRemark">确定</el-button>
          </sapn>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="拒件说明" span="3">
        <div>
          <div>{{ info.remarksDriver || '-' }}</div>
          <div v-if="info.remarksDriverImg" class="flex-start">
            <div
              v-for="item in info.remarksDriverImg.split(',')"
              :key="item"
              class="margin-right-10"
            >
              <el-image
                style="width: 50px; height: 50px"
                :src="item"
                :preview-src-list="info.remarksDriverImg.split(',')"
              />
            </div>
          </div>
        </div>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script >
import { inject, ref, computed } from '@vue/composition-api';
import { isValidPhoneNumber } from '@/util/util';
import { Loading, Message } from 'element-ui';
import { changeContact, sysRemark } from '@/api/express/order';
import { phoneUrl } from '@/views/order/intercity/utils';
const __sfc_main = {};
__sfc_main.props = {
  info: {
    type: Object,
    default: () => {}
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const isOpenSet = ref(false);
  const isOpenRemark = ref(false);
  const newMobile = ref('');
  const newRemark = ref('');
  const getDetail = inject('getDetail');
  const userList = computed(() => {
    const {
      userMap
    } = props.info || {};
    return Object.keys(userMap || {}) || [];
  });
  const handleOpenSet = () => {
    isOpenSet.value = true;
  };
  const phoneCancel = () => {
    isOpenSet.value = false;
    newMobile.value = '';
  };
  const submit = async () => {
    if (!isValidPhoneNumber(newMobile.value)) {
      Message.error('请输入正确手机号码！');
      return;
    }
    const parmas = {
      id: props.info.id,
      phone: newMobile.value,
      type: 1
    };
    Loading.service();
    const {
      code
    } = await changeContact(parmas);
    if (code === 0) {
      Message.success('操作成功');
      phoneCancel();
      getDetail(props.info.id);
    }
    Loading.service().close();
  };
  const openBtn = () => {
    isOpenRemark.value = true;
  };
  const remarkCancel = () => {
    isOpenRemark.value = false;
    newRemark.value = '';
  };
  const sumitRemark = async () => {
    if (!newRemark.value) {
      Message.error('请输入备注！');
      return;
    }
    const parmas = {
      id: props.info.id,
      remark: newRemark.value
    };
    Loading.service();
    const {
      code
    } = await sysRemark(parmas);
    if (code === 0) {
      Message.success('操作成功');
      remarkCancel();
      getDetail(props.info.id);
    }
    Loading.service().close();
  };
  return {
    phoneUrl,
    isOpenSet,
    isOpenRemark,
    newMobile,
    newRemark,
    userList,
    handleOpenSet,
    phoneCancel,
    submit,
    openBtn,
    remarkCancel,
    sumitRemark
  };
};
export default __sfc_main;
</script>

<style lang="scss" scoped>
  ::v-deep .el-button--mini {
    padding: 6px 10px;
  }
</style>
